import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
const ProtectedRoute = ({
  children,
  requiredUserType
}) => {
  const {
    user,
    isLoggedIn
  } = useAuth();
  if (!isLoggedIn) {
    // Redirect to login if not logged in
    return <Navigate to="/login" data-id="element-182" />;
  }
  // If requiredUserType is specified, check if user has the required type
  if (requiredUserType && user.User_type !== requiredUserType) {
    // Redirect to appropriate dashboard based on user type
    if (user.User_type === 'admin') {
      return <Navigate to="/admin" data-id="element-183" />;
    } else if (user.User_type === 'delivery') {
      return <Navigate to="/delivery" data-id="element-184" />;
    } else {
      return <Navigate to="/customer" data-id="element-185" />;
    }
  }
  // If user is authenticated and has the required user type (or no specific type is required),
  // render the protected component
  return children;
};
export default ProtectedRoute;